import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';

import { toProductShape } from 'lib/util/productShape';
import { Reservation } from 'models/reservation';
import { ReduxState } from 'ducks';
import styles from './InquiryForm.module.css';

const getGuestFamilyName = (reservation: Reservation): string => {
  return (
    reservation.field_responses?.find((f) => f.key === 'family_name')?.response ??
    reservation.field_responses?.find((f) => f.key === 'kana_family_name')?.response ??
    ''
  );
};

const getGuestGivenName = (reservation: Reservation): string => {
  return (
    reservation.field_responses?.find((f) => f.key === 'given_name')?.response ??
    reservation.field_responses?.find((f) => f.key === 'kana_given_name')?.response ??
    ''
  );
};

export const InquiryBookingSummary = () => {
  const { i18n, t } = useTranslation();

  const reservation = useSelector((state: ReduxState) => state.server.reservation.reservation);
  const product = useSelector((state: ReduxState) => state.server.product.product);

  if (!reservation || !product) return null;

  const productShape = toProductShape(product);

  const thumbnailUrl = productShape.mediaURLs.find((item) => item.type === 'IMAGE')?.url;

  const guestGivenName = getGuestGivenName(reservation);
  const guestFamilyName = getGuestFamilyName(reservation);

  return (
    <div className={styles['post-main__menu']}>
      {thumbnailUrl && <img className={styles['post-main__menu__pic']} src={thumbnailUrl} />}
      <div className={styles['post-main__menu__info']}>
        <p className={styles['post-main__menu__info__date']}>
          {moment
            .tz(reservation.start_date_time_utc, reservation.start_timezone || '')
            .locale(i18n.language)
            .format('YYYY/MM/DD')}
        </p>
        <p className={styles['post-main__menu__info__ttl']}>{reservation.product_name}</p>
        <p className={styles['post-main__menu__info__name']}>
          {t('{{guestGivenName}} {{guestFamilyName}}', {
            guestGivenName,
            guestFamilyName,
          })}
        </p>
      </div>
    </div>
  );
};
